import { render } from "./SingleFeedback.vue?vue&type=template&id=3047c3cc&scoped=true"
import script from "./SingleFeedback.vue?vue&type=script&lang=js"
export * from "./SingleFeedback.vue?vue&type=script&lang=js"

import "./SingleFeedback.vue?vue&type=style&index=0&id=3047c3cc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3047c3cc"]])

export default __exports__